import axios, { AxiosInstance } from 'axios'
import Configuration from '../domain/Configuration'
import RegionService from './RegionService'

export default class WallexService {
    static instance(): AxiosInstance {
        return axios.create({
            baseURL: Configuration.BASE_URL,
            headers: {
                region: RegionService.get(),
            },
        })
    }

    // Appends the reason (simulator-server's { error: { message } }, or the error's own message) to the fallback text
    static errorDescription(error: unknown, fallback: string): string {
        let reason: string | undefined
        if (axios.isAxiosError<{ error?: { message?: string } }>(error)) {
            // No response means the simulator service couldn't be reached
            reason = error.response ? error.response.data?.error?.message : error.message
        } else if (error instanceof Error) {
            reason = error.message
        }
        return reason ? `${fallback} (${reason})` : fallback
    }
}
